__turbopack_context__.v({
  "root": "EventsViewToggle-module-scss-module__rFpt6G__root",
  "toggleGroup": "EventsViewToggle-module-scss-module__rFpt6G__toggleGroup",
  "toggleItem": "EventsViewToggle-module-scss-module__rFpt6G__toggleItem",
  "toggleItemActive": "EventsViewToggle-module-scss-module__rFpt6G__toggleItemActive",
});
